import React from 'react';
import { Link } from 'react-router-dom';
import useDeleteFavoriteJob from '../../../hooks/favouriteJobs/useDeleteFavouriteJob';
import './favouriteJobCard.css'
import { shopIcon, usersIcon, locationIcon, starIcon, contractIcon, timerIcon } from '../../../utils/icons';
import useSignedImage from '../../../hooks/useSignedImage';

const FavouriteJobCard = ({ data, onDeleteSuccess }) => {
  const { deleteFavoriteJob, loading, error, success } = useDeleteFavoriteJob();
  const { jobOffer } = data;

  const {
    id,
    position,
    location,
    schedule,
    vacancies,
    description,
    yearsOfExperience,
    createdAt,
    restaurant,
    contract,
  } = jobOffer;

  const imagePath = restaurant.profileImageUrl || '/logo192.png';
  const { imageUrl: signedImageUrl } = useSignedImage(imagePath, '/default-restaurant.png');

  const locationDisplay = location?.address || 'No hay';

  const handleDelete = async () => {
    await deleteFavoriteJob(id);
    onDeleteSuccess()
  };

  return (
    <div className="favourite-job-card__container">
      <div className="favourite-job-card__col-1">
        <img 
          className="favourite-job-card__company-logo" 
          src={signedImageUrl}
          alt={`Logo de ${restaurant.name}`}
          onError={(e) => {
            console.warn('FavouriteJobCard - Image failed to load:', signedImageUrl);
            e.target.src = '/logo192.png';
          }}
        />
        <div className="favourite-job-card__info">
          <div className="favourite-job-card__info-main">
            <p><strong>{position}</strong></p>
            <p id="favourite-job-card__company-name"><strong>{restaurant.name}</strong></p>
          </div>
          <div className="favourite-job-card__info-footer-container">
            <div className="favourite-job-card__icon-title-container">
             {shopIcon}
             <div className="favourite-job-card__label-info-container">
              <p><strong>Nombre:</strong></p>
              <p>{restaurant.name}</p>
             </div>
            </div>
            <div className="favourite-job-card__icon-title-container">
              {locationIcon}
              <div className="favourite-job-card__label-info-container">
                <p><strong>Ubicación:</strong></p>
                <p>{locationDisplay}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="favourite-job-card__col-2">
        <div className="favourite-job-card__icons-posts_container">
          <div className="favourite-job-card__icon-title-container">
            {timerIcon}
            <div className="favourite-job-card__label-info-container">
              <strong><p>Jornada:</p></strong>
              <p>{schedule}</p>
            </div>
          </div>
          <div className="favourite-job-card__icon-title-container">
           {starIcon} 
           <div className="favourite-job-card__label-info-container">
             <strong><p>Experiencia:</p></strong>
             <p>{yearsOfExperience}</p>
           </div>
          </div>
          <div className="favourite-job-card__icon-title-container">
            {contractIcon}
            <div className="favourite-job-card__label-info-container">
              <strong><p>Contrato:</p></strong>
              <p>{contract}</p>
            </div>
          </div>
          <div className="favourite-job-card__icon-title-container">
            {usersIcon}
            <div className="favourite-job-card__label-info-container">
             <strong><p>Vacantes:</p></strong>
             <p>{vacancies}</p>
            </div>
          </div>
        </div>
        <div className="favourite-job-card__description-buttons-container">
          <div  className="favourite-job-card__description-container">
            <div className="favourite-job-card__description">
              {description}
            </div>
            <h5>Publicado el {new Date(createdAt).toLocaleDateString()}</h5>
          </div>
          <div className="favourite-job-card__button-container">
              <Link to={`/trabajos/${id}`}>
              <button className="favourite-job-card__post-button">Postular</button>
            </Link>
              <button onClick={handleDelete} className='favourite-job-card__post-button'>Eliminar</button>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default FavouriteJobCard;
